import { BACKEND_BASE_URL } from "../config/env";
import { COURIER_LABELS } from "../constants/couriers";

export { COURIER_LABELS };

/**
 * Client-side pattern matcher (0ms latency)
 */
export function detectCourierClient(resiInput) {
  const resi = (resiInput || "").trim().toUpperCase();
  if (!resi) {
    return { suggestedCourier: null, confidence: "none", label: null };
  }

  // J&T Express: JP, JX, JZ, TJNT, JS, JNT, TM, JO, JU, JD, JD0
  if (/^(JP|JX|JZ|TJNT|JS|JNT|TM|JO|JU|JD|JD0)\d{8,14}$/i.test(resi)) {
    return { suggestedCourier: "jnt", confidence: "high", label: COURIER_LABELS.jnt };
  }
  // J&T Cargo: JTC, 201..., 570..., 100...
  if (/^JTC\d{7,12}$/i.test(resi) || /^(300|200|900|201|570)\d{7,9}$/.test(resi) || /^100[1-9]\d{8}$/.test(resi)) {
    return { suggestedCourier: "jnt_cargo", confidence: "high", label: COURIER_LABELS.jnt_cargo };
  }
  // SPX (Shopee Express): SPXID, SPX, ID, 260...
  if (/^(SPXID|SPX)\w+$/i.test(resi) || /^ID0\d{9,13}[A-Z0-9]?$/i.test(resi)) {
    return { suggestedCourier: "spx", confidence: "high", label: COURIER_LABELS.spx };
  }
  // SiCepat Ekspres: 00..., 004...
  if (/^00\d{10}$/.test(resi) || /^004\d{9}$/.test(resi)) {
    return { suggestedCourier: "sicepat", confidence: "high", label: COURIER_LABELS.sicepat };
  }
  // AnterAja: 1000..., 1100..., 10..., 11... (12-15 digits), TSA-, AL
  if (/^(1000|1001|1002|1003|1004|1005|1006|1007|1008|1009|1100|110|100|10|11)\d{10,13}$/.test(resi) || /^(1000|100)\d{8,9}$/.test(resi) || /^AL\d{10,12}$/i.test(resi) || /^TSA-?\d+$/i.test(resi)) {
    return { suggestedCourier: "anteraja", confidence: "high", label: COURIER_LABELS.anteraja };
  }
  // Ninja Xpress: NLID, SHP, NVID, NJV
  if (/^(NLID|SHP|NVID|NID|NIDN|NV|NJV)\w+$/i.test(resi)) {
    return { suggestedCourier: "ninja", confidence: "high", label: COURIER_LABELS.ninja };
  }
  // Lion Parcel: LP, 11LP, TSLP
  if (/^LP\d{8,14}$/i.test(resi) || /^11LP\d+$/i.test(resi) || /^TSLP-\d+$/i.test(resi) || /^\d{2}-\d{2}-\d{8,10}$/.test(resi)) {
    return { suggestedCourier: "lion", confidence: "high", label: COURIER_LABELS.lion };
  }
  // POS Indonesia: EE...ID, RR...ID, P26..., TTSPOS
  if (/^[A-Z]{2}\d{9}ID$/i.test(resi) || /^P2?\d{9,11}$/i.test(resi) || /^TTSPOS\d+$/i.test(resi)) {
    return { suggestedCourier: "pos", confidence: "high", label: COURIER_LABELS.pos };
  }
  // ID Express: IDS, IDE, IDP
  if (/^(IDS|IDE|IDP)\d{8,12}$/i.test(resi)) {
    return { suggestedCourier: "ide", confidence: "high", label: COURIER_LABELS.ide };
  }
  // Paxel: EM., PX, TSPX-
  if (/^(EM\.|PX|TSPX-)\w+$/i.test(resi)) {
    return { suggestedCourier: "paxel", confidence: "high", label: COURIER_LABELS.paxel };
  }
  // JNE Express: CGK, SUB, BDO, SOC, JNE, TG00, CM5
  if (/^(CGK|SUB|BDO|SOC|JNE|TGR|DPS|BPN|MES|UPG|KNO|PKU|PLM|SMG|YOG|MLG|CM|TG00)\w+$/i.test(resi)) {
    return { suggestedCourier: "jne", confidence: "high", label: COURIER_LABELS.jne };
  }
  // Tiki: 66, 66010...
  if (/^(66|02|03)\d{10}$/.test(resi)) {
    return { suggestedCourier: "tiki", confidence: "high", label: COURIER_LABELS.tiki };
  }
  // Indah Cargo: Kode cabang (3 huruf) + 1CS/1CSPL + 12+ digit angka
  if (/^[A-Z]{3}1CS(PL)?[0-9]{12,}$/i.test(resi)) {
    return { suggestedCourier: "indah_cargo", confidence: "high", label: COURIER_LABELS.indah_cargo };
  }
  // Wahana: 8 karakter alfanumerik acak (contoh: ZYRPCRHA, DK2YGRHB) atau AA123456
  if (/^[A-Z]{2}\d{6,8}$/i.test(resi) || (resi.length === 8 && /^[A-Z0-9]{8}$/i.test(resi))) {
    return { suggestedCourier: "wahana", confidence: "high", label: COURIER_LABELS.wahana };
  }
  // SAP Express
  if (/^(SAP|UOS|UDR)\d{8,12}$/i.test(resi)) {
    return { suggestedCourier: "sap", confidence: "high", label: COURIER_LABELS.sap };
  }
  // Lazada Express: LXAD-, LXA, LE, NL, LAZ
  if (/^(LXAD|LXA|LE|NL|LAZ)\w+$/i.test(resi)) {
    return { suggestedCourier: "lex", confidence: "high", label: COURIER_LABELS.lex };
  }
  // GTL: TKGTL-000006488L1, TKGTL-000002GH69H
  if (/^TKGTL-[A-Z0-9]{8,14}$/i.test(resi)) {
    return { suggestedCourier: "gtl", confidence: "high", label: COURIER_LABELS.gtl };
  }
  // Kurir Tokopedia: TKP, TKPD
  if (/^TKP\w+$/i.test(resi)) {
    return { suggestedCourier: "kurir_tokopedia", confidence: "high", label: COURIER_LABELS.kurir_tokopedia };
  }

  // Medium confidence numeric patterns
  if (/^0\d{11}$/.test(resi)) {
    return { suggestedCourier: "sicepat", confidence: "medium", label: COURIER_LABELS.sicepat };
  }
  if (/^\d{12}$/.test(resi)) {
    return { suggestedCourier: "jne", confidence: "medium", label: COURIER_LABELS.jne };
  }

  return { suggestedCourier: null, confidence: "none", label: null };
}

/**
 * Combined Client + Backend API Auto Detect
 */
export async function detectCourierWithBackend(resiInput) {
  const clientRes = detectCourierClient(resiInput);
  if (clientRes.confidence === "high") {
    return { ...clientRes, source: "client_regex" };
  }

  const resi = (resiInput || "").trim();
  if (!resi || !BACKEND_BASE_URL) {
    return clientRes;
  }

  try {
    const res = await fetch(`${BACKEND_BASE_URL}/tracking/detect?resi=${encodeURIComponent(resi)}`);
    if (!res.ok) {
      return clientRes;
    }
    const json = await res.json();
    if (json?.status === "success" && json.suggested_courier) {
      const courierCode = json.suggested_courier;
      return {
        suggestedCourier: courierCode,
        confidence: json.confidence || "high",
        score: json.confidence_score || 0.9,
        source: json.source || "backend_db",
        label: COURIER_LABELS[courierCode] || courierCode.toUpperCase(),
        message: json.message || "",
      };
    }
  } catch (e) {
    console.error("Failed to query /tracking/detect", e);
  }

  return clientRes;
}

/**
 * Fetch dynamic pattern summaries for courier guide cards
 */
export async function fetchCourierPatterns() {
  if (!BACKEND_BASE_URL) {
    return null;
  }

  try {
    const res = await fetch(`${BACKEND_BASE_URL}/tracking/patterns`);
    if (!res.ok) {
      return null;
    }
    const json = await res.json();
    if (json?.status === "success" && Array.isArray(json.patterns)) {
      return json.patterns;
    }
  } catch (e) {
    console.error("Failed to fetch /tracking/patterns", e);
  }
  return null;
}
